import request from './index';

// 创建分类
export const createCategory = (data) => {
  return request({
    url: '/api/categories/create',
    method: 'post',
    data
  });
};

// 获取分类列表
export const getCategoryList = () => {
  return request({
    url: '/api/categories/list',
    method: 'get'
  });
};

// 添加图片到分类
export const addImageToCategory = (data) => {
  return request({
    url: '/api/categories/add-image',
    method: 'post',
    data
  });
};

// 获取分类下的图片
export const getCategoryImages = (categoryId) => {
  return request({
    url: `/api/categories/images/${categoryId}`,
    method: 'get'
  });
};

// 获取分类详情（包含图片）
export const getCategoryDetail = (categoryId) => {
  return request({
    url: `/api/categories/${categoryId}`,
    method: 'get'
  });
};

// 编辑分类
export const editCategory = (categoryId, data) => {
  return request({
    url: `/api/categories/edit/${categoryId}`,
    method: 'put',
    data
  });
};

// 删除分类
export const deleteCategory = (categoryId) => {
  return request({
    url: `/api/categories/delete/${categoryId}`,
    method: 'delete'
  });
};

// 删除分类下的图片
export const deleteCategoryImage = (imageId) => {
  return request({
    url: `/api/categories/delete-image/${imageId}`,
    method: 'delete'
  });
};